<app-modal-shell [config]="modalConfig">
  <form modal-content [formGroup]="form" class="history-form">
    <app-unit-selector
      class="full-width"
      label="Comunidad"
      [required]="true"
      [unitSource]="allCommunities"
      [groupByLevel]="true"
      groupByMode="ancestors"
      [loading]="isLoadingCommunities"
      formControlName="organizationUnitId"
      (unitSelected)="onCommunitySelected($event)">
    </app-unit-selector>

    <app-date-picker
      class="full-width"
      label="Fecha desde"
      formControlName="validFrom"
      [min]="minDate"
      [max]="maxDate"
      [errorMessages]="{
        required: 'La fecha desde es requerida.',
        matDatepickerParse: 'Ingresa una fecha valida con formato dd/mm/aaaa.',
        matDatepickerMin: 'La fecha no puede ser anterior a la fecha de nacimiento.',
        matDatepickerMax: 'La fecha no puede ser posterior a hoy.',
        futureDate: 'La fecha no puede ser posterior a hoy.'
      }">
    </app-date-picker>

    <mat-form-field class="full-width" *ngIf="isCreateMode || !isSyntheticRecord">
      <mat-label>Motivo <span class="optional-hint">(opcional)</span></mat-label>
      <textarea matInput formControlName="reason" rows="2" maxlength="300"></textarea>
      <mat-hint align="end">{{ form.get('reason')?.value?.length || 0 }}/300</mat-hint>
    </mat-form-field>
  </form>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" (click)="onConfirm()" [disabled]="isLoadingCommunities">
      Guardar
    </button>
  </ng-container>
</app-modal-shell>
